export const VIEW_ALL_COURSE_CART_ITEMS = 'VIEW_ALL_COURSE_CART_ITEMS'

export const DELETE_COURSE_CART_ITEM = 'DELETE_COURSE_CART_ITEM'



